import { WORK_PAGES } from "../work/pages"
// Navigation settings (as configured on the Framer canvas).
const font = (family: string, weight: number, size?: string) => ({
    fontFamily: `"${family}", "${family} Placeholder", sans-serif`,
    fontStyle: "normal",
    fontWeight: weight,
    ...(size ? { fontSize: size, letterSpacing: "0em", lineHeight: "1em" } : {}),
})
/** The work categories, in menu order. A category with a work page links to it
 *  and counts its cases (shown in the menu); the others are not live yet. */
const categories = (labels: string[]) =>
    labels.map((label) => {
        const page = WORK_PAGES[label.toLowerCase()]
        return { id: label.toLowerCase(), label, href: page?.path || "", count: page ? page.cases.length : 0 }
    })

/** main menu: one for every page */
export const MENU = {
    menuFont: font("Blubird Bold Display", 700, "16px"),
    submenuFont: font("Blubird Semi Bold Display", 600, "16px"),
    categories: categories(["Sports", "Automotive", "Travel", "Fashion", "Lifestyle"]),
}
/** section indicator and category tab on the work pages */
export const CHROME = {
    barStep: 16, // bar length per section
    blur: 30, // background blur of the glass shapes (as in Figma)
    clients: 1, // fewest dots in the indicator: one dot per case on the page
    previewSections: 6,
}
export const WORK_URL = "/sports"
